import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { OwnerCenter } from './pages/OwnerCenter';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { PixelRouteTracker } from './components/PixelRouteTracker';
import { SiteMeta } from './components/SiteMeta';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}

// Loads the Meta Pixel and fires PageView the moment the site's code loads, before
// anything renders, so no visit is missed and later events (ViewContent) always find it.
initPixels();
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3ihv1odb3qjic">
      <ScrollToHash data-id="element-1" data-mp="3mljat0fdtn5p" />
      <PixelRouteTracker data-id="element-2" data-mp="3ml12v6jcxkhy" />
      <SiteMeta data-id="element-3" data-mp="3mk868ye44bdj" />
      <Routes data-id="element-4" data-mp="3mjq27fl7ksv2">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-6" data-mp="3rbzomln47asl" />} data-id="element-5" data-mp="3mjgclt42snpw" />
        <Route path="/verify" element={<Authenticity data-id="element-8" data-mp="5ggje8nxyxz" />} data-id="element-7" data-mp="67yvnd9206b" />
        <Route path="/rewards" element={<CrewRewards data-id="element-10" data-mp="2zllduyaeeel5" />} data-id="element-9" data-mp="7svdij4jt6t" />
        <Route path="/activate" element={<Activate data-id="element-12" data-mp="2zn6cayzu2hoa" />} data-id="element-11" data-mp="2zmeoiach9o8k" />
        <Route path="/owner" element={<OwnerCenter data-id="element-14" data-mp="33nq5xsl7735o" />} data-id="element-13" data-mp="33mf3bw3ho1g5" />
        <Route path="/guide" element={<Guide data-id="element-16" data-mp="33oi0d0326uud" />} data-id="element-15" data-mp="33n6w6z5pbl2q" />
        <Route path="/track" element={<TrackOrder data-id="element-18" data-mp="38l03xwmnkn54" />} data-id="element-17" data-mp="38l8idsyfc0if" />
        <Route path="/legal/:slug" element={<Legal data-id="element-20" data-mp="3dkl58dpap7l0" />} data-id="element-19" data-mp="38kgocmkh6au9" />
        <Route path="*" element={<Legal data-id="element-22" data-mp="3dmfprqwnmxok" />} data-id="element-21" data-mp="3dl4kfmnk9hvc" />
      </Routes>
    </BrowserRouter>;
}